const productData = [
  {
    id: 1,
    name: "BRONTO PLATE SET OF 2",
    price: "38.00",
    country: "Margotal",
    reviews: "124 Reviews",
    images: ["/img/101.webp"],
    size: ["One Size"],
    description: [
      "A set of two ceramic plates in a vibrant yellow glaze, part of the Bronto collection.",
      "Designed with Margotal's signature minimalist aesthetic, these plates feature a smooth glazed finish and subtle rim detail.",
      "The cheerful yellow hue adds a pop of colour to any table setting while maintaining the brand's refined sensibility.",
      "Perfect for everyday dining or special occasions, combining form and function in true Margotal style.",
      "Each plate is carefully crafted to ensure durability and timeless appeal.",
      "Dishwasher and microwave safe for practical everyday use.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Homeware, Ceramics",
      "Material: High-quality ceramic with yellow glaze finish",
      "Set includes: 2 plates",
      "Diameter: Approximately 21cm",
      "Care: Dishwasher and microwave safe",
      "Design: Minimalist Japanese-inspired aesthetic",
      "Origin: Made in collaboration with traditional ceramic artisans",
      "Color: Warm yellow",
      "Style: Contemporary, functional design",
    ],
  },
  {
    id: 2,
    name: "BRONTO EGG CUP SET OF 2",
    price: "28.00",
    country: "Margotal",
    reviews: "98 Reviews",
    images: ["/img/102.webp"],
    size: ["One Size"],
    description: [
      "Two ceramic egg cups in the distinctive Bronto yellow glaze, perfectly sized for soft-boiled eggs.",
      "The gentle bowl shape and wide base provide stability while the glossy finish adds a touch of elegance to breakfast time.",
      "Margotal's attention to detail is evident in the smooth curves and balanced proportions.",
      "These egg cups embody the brand's philosophy of finding beauty in everyday objects.",
      "A delightful addition to your morning routine, combining practicality with aesthetic appeal.",
      "Makes an excellent gift for those who appreciate thoughtful design.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Homeware, Ceramics",
      "Material: Ceramic with glossy yellow glaze",
      "Set includes: 2 egg cups",
      "Dimensions: 5cm height, 6cm diameter",
      "Care: Dishwasher safe",
      "Design: Classic egg cup shape with modern finish",
      "Color: Vibrant yellow",
      "Style: Functional breakfast ware",
      "Perfect for: Soft-boiled eggs",
    ],
  },
  {
    id: 3,
    name: "BRONTO MUG SET OF 2",
    price: "45.00",
    country: "Margotal",
    reviews: "156 Reviews",
    images: ["/img/103.webp"],
    size: ["One Size"],
    description: [
      "A pair of ceramic mugs in the signature Bronto yellow, designed for daily use and lasting enjoyment.",
      "The generous capacity and comfortable handle make these mugs perfect for your morning coffee or afternoon tea.",
      "Crafted with a thick, durable ceramic body that retains heat beautifully.",
      "The glossy yellow glaze creates a cheerful presence on any kitchen shelf or dining table.",
      "Margotal's commitment to quality ensures these mugs will become beloved everyday essentials.",
      "The cylindrical form reflects the brand's appreciation for simple, enduring design.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Homeware, Ceramics",
      "Material: Thick-walled ceramic with yellow glaze",
      "Set includes: 2 mugs",
      "Capacity: 300ml each",
      "Height: 9cm",
      "Care: Dishwasher and microwave safe",
      "Handle: Comfortable grip design",
      "Color: Bright yellow",
      "Style: Contemporary minimalist",
    ],
  },
  {
    id: 4,
    name: "MHL. CHUNKY HIGH NECK SWEATER",
    price: "245.00",
    country: "MHL.",
    reviews: "87 Reviews",
    images: ["/img/104.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "A chunky knit high neck sweater in warm brown, exemplifying MHL.'s relaxed yet refined aesthetic.",
      "Crafted from premium wool blend with a substantial gauge for excellent warmth and structure.",
      "The generous turtleneck provides extra comfort and protection from cold weather.",
      "Features ribbed cuffs and hem for a secure fit and classic finish.",
      "The boxy silhouette offers a contemporary, oversized fit that works beautifully with both skirts and trousers.",
      "Perfect for layering or wearing as a statement piece throughout autumn and winter.",
      "Made in collaboration with skilled knitters who understand the importance of quality construction.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Clothing, Knitwear",
      "Material: 85% Wool, 15% Cashmere blend",
      "Gauge: Chunky knit",
      "Neckline: High turtleneck",
      "Fit: Relaxed, slightly oversized",
      "Sleeves: Long sleeves with ribbed cuffs",
      "Hem: Ribbed finish",
      "Color: Warm brown/taupe",
      "Care: Dry clean or gentle hand wash",
      "Season: Autumn/Winter",
      "Style: Contemporary minimalist",
    ],
  },
  {
    id: 5,
    name: "CHUNKY NECKWARMER",
    price: "85.00",
    country: "Margotal",
    reviews: "145 Reviews",
    images: ["/img/105.webp"],
    size: ["One Size"],
    description: [
      "A luxuriously soft neckwarmer in rich rust orange, knitted in a chunky ribbed pattern.",
      "The wrap-around design provides versatile styling options and exceptional warmth.",
      "Made from a premium wool blend that's soft against the skin while providing excellent insulation.",
      "The vibrant rust colour adds a warm accent to autumn and winter wardrobes.",
      "Designed to be worn loosely draped or wrapped snugly for maximum comfort.",
      "The substantial gauge ensures this piece will maintain its shape season after season.",
      "A perfect example of Margotal's ability to elevate functional accessories.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Scarves",
      "Material: 100% Lambswool",
      "Knit: Chunky ribbed texture",
      "Length: 70cm",
      "Width: 25cm",
      "Color: Rust orange",
      "Weight: Medium-heavy",
      "Care: Hand wash cold, lay flat to dry",
      "Style: Versatile wrap design",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
    ],
  },
  {
    id: 6,
    name: "KNITTED PLEAT SKIRT",
    price: "295.00",
    country: "Margotal",
    reviews: "112 Reviews",
    images: ["/img/106.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "An elegant knitted pleat skirt in deep black, showcasing Margotal's sophisticated approach to knitwear.",
      "The knife pleats create beautiful movement and drape while the knitted construction adds comfort and ease.",
      "Falls to a flattering midi length, perfect for both professional and casual settings.",
      "The elasticated waistband ensures comfort without compromising the refined silhouette.",
      "Pairs beautifully with simple knits and shirts for a polished, contemporary look.",
      "The substantial knit weight provides structure while remaining comfortable for all-day wear.",
      "A versatile piece that transitions seamlessly from office to evening.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Clothing, Skirts & Dresses",
      "Material: 70% Wool, 30% Polyester blend",
      "Style: Knife pleated midi skirt",
      "Length: Midi (approximately 70cm from waist)",
      "Waist: Elasticated for comfort",
      "Color: Deep black",
      "Fit: Relaxed A-line silhouette",
      "Care: Dry clean only",
      "Season: Autumn/Winter",
      "Lining: Fully lined",
      "Origin: Made in Europe",
    ],
  },
  {
    id: 7,
    name: "LONG CUFF GLOVE",
    price: "68.00",
    country: "Margotal",
    reviews: "134 Reviews",
    images: ["/img/107.jpg"],
    size: ["S/M", "M/L"],
    description: [
      "Classic long cuff gloves in soft grey melange, featuring extended ribbed cuffs for extra warmth.",
      "Knitted from fine gauge wool for a smooth, comfortable fit that layers easily under coat sleeves.",
      "The elongated cuffs can be worn pulled up for maximum coverage or folded down for a casual look.",
      "Touchscreen-compatible fingertips allow you to use your devices without removing the gloves.",
      "The neutral grey colour complements any winter wardrobe.",
      "Perfectly balanced between function and style, these gloves embody Margotal's practical elegance.",
      "Crafted with attention to detail, from the seamless knitting to the reinforced fingertips.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Gloves",
      "Material: 100% Merino Wool",
      "Knit: Fine gauge jersey",
      "Cuff: Extended ribbed design (8cm)",
      "Color: Grey melange",
      "Features: Touchscreen compatible",
      "Length: Extended cuff style",
      "Care: Hand wash cold, reshape and dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Fit: True to size with slight stretch",
    ],
  },
  {
    id: 8,
    name: "BEDALE GILET",
    price: "425.00",
    country: "Margotal x Barbour",
    reviews: "76 Reviews",
    images: ["/img/108.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "A sleeveless interpretation of the classic Bedale jacket, created in collaboration with Barbour.",
      "Features the iconic waxed cotton exterior that improves with age and weather exposure.",
      "Multiple patch pockets with storm flap closures provide ample storage and authentic detailing.",
      "The corduroy collar adds a refined touch and extra comfort around the neck.",
      "Perfect for layering over knitwear during transitional seasons or under heavier coats in winter.",
      "The gilet silhouette offers freedom of movement while maintaining core warmth.",
      "Combines Barbour's heritage craftsmanship with Margotal's contemporary sensibility.",
      "Suitable for country walks, city streets, or weekend adventures.",
    ],
    Features: [
      "Brand: Margotal x Barbour",
      "Category: Clothing, Outerwear",
      "Material: Barbour's signature waxed cotton (6oz Sylkoil)",
      "Collar: Corduroy",
      "Pockets: Multiple patch pockets with storm flaps",
      "Closure: Press stud front fastening",
      "Lining: Barbour tartan",
      "Color: Black",
      "Fit: Relaxed, true to size",
      "Care: Re-wax annually, sponge clean",
      "Season: Autumn/Winter/Spring",
      "Origin: Made in England",
    ],
  },
  {
    id: 9,
    name: "MHL. SIMPLE RIBBED BEANIE",
    price: "65.00",
    country: "MHL.",
    reviews: "203 Reviews",
    images: ["/img/109.webp"],
    size: ["One Size"],
    description: [
      "A timeless ribbed beanie in warm camel, knitted from soft lambswool for superior warmth and comfort.",
      "The classic fisherman's rib construction provides excellent insulation and stretch.",
      "Features a distinctive top knot detail that adds character without compromising the minimalist design.",
      "The fold-up cuff allows you to adjust the fit and coverage to your preference.",
      "Lightweight yet warm, this beanie is perfect for layering without adding bulk.",
      "The neutral camel shade pairs effortlessly with any autumn or winter wardrobe.",
      "A versatile essential that exemplifies MHL.'s focus on functional, everyday pieces.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Accessories, Hats",
      "Material: 100% Lambswool",
      "Knit: Fisherman's rib",
      "Detail: Top knot finish",
      "Cuff: Fold-up design",
      "Color: Camel/tan",
      "Fit: One size fits most",
      "Care: Hand wash cold, dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Weight: Lightweight",
    ],
  },
  {
    id: 10,
    name: "FINE GAUGE BEANIE",
    price: "58.00",
    country: "Margotal",
    reviews: "167 Reviews",
    images: ["/img/1010.webp"],
    size: ["One Size"],
    description: [
      "A refined fine gauge beanie in classic navy, showcasing Margotal's attention to quality and detail.",
      "Knitted from merino wool in a tight fine gauge for a smooth, sophisticated finish.",
      "The watch cap style with fold-up cuff is a timeless design that suits all face shapes.",
      "Sits comfortably without being too tight, providing warmth without compromising style.",
      "The deep navy colour is versatile and practical, coordinating with everything in your wardrobe.",
      "Fine enough to wear under a hood yet warm enough to wear on its own.",
      "Minimal branding maintains the clean, understated aesthetic Margotal is known for.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Hats",
      "Material: 100% Merino Wool",
      "Knit: Fine gauge jersey",
      "Style: Watch cap with fold-up cuff",
      "Color: Navy",
      "Fit: One size, stretches to fit comfortably",
      "Care: Hand wash cold, reshape and dry flat",
      "Season: Autumn/Winter",
      "Weight: Medium-light",
      "Origin: Made in Scotland",
      "Details: Clean, minimal design without logos",
    ],
  },
  {
    id: 11,
    name: "CHUNKY WRISTWARMER",
    price: "75.00",
    country: "Margotal",
    reviews: "128 Reviews",
    images: ["/img/1011.webp"],
    size: ["One Size"],
    description: [
      "Fingerless wristwarmers in rich rust orange, knitted in a substantial chunky gauge.",
      "The fingerless design allows full dexterity while keeping hands and wrists warm.",
      "Perfect for working, driving, or outdoor activities where you need finger mobility.",
      "Extended length provides coverage from knuckles to mid-forearm.",
      "The vibrant rust colour matches beautifully with the Chunky Neckwarmer for a coordinated look.",
      "Made from soft lambswool that's warm yet breathable.",
      "Ribbed edges ensure the wristwarmers stay in place throughout the day.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Gloves",
      "Material: 100% Lambswool",
      "Style: Fingerless wristwarmer",
      "Knit: Chunky gauge with ribbed texture",
      "Length: Extended (approximately 20cm)",
      "Color: Rust orange",
      "Fit: One size with stretch",
      "Care: Hand wash cold, dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Detail: Ribbed cuffs for secure fit",
    ],
  },
  {
    id: 12,
    name: "SHEARLING CROPPED JACKET",
    price: "1,250.00",
    country: "Margotal",
    reviews: "45 Reviews",
    images: ["/img/1012.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "A luxurious cropped shearling jacket in rich tan suede with natural cream shearling lining.",
      "The classic aviator-inspired silhouette is updated with Margotal's contemporary proportions.",
      "Featuring wooden toggle button closures for an authentic, heritage feel.",
      "The cropped length creates a modern, flattering profile that works with high-waisted trousers and skirts.",
      "Generously lined with plush shearling for exceptional warmth and comfort.",
      "The suede exterior develops a beautiful patina with wear, making each jacket unique.",
      "Oversized patch pockets provide practical storage and emphasize the workwear influence.",
      "An investment piece that will remain a wardrobe staple for years to come.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Clothing, Outerwear",
      "Material: Premium suede leather exterior",
      "Lining: 100% natural shearling",
      "Closure: Wooden toggle buttons",
      "Pockets: Two large patch pockets",
      "Length: Cropped at waist",
      "Color: Tan suede with cream shearling",
      "Fit: Relaxed with room for layering",
      "Collar: Shearling notch collar",
      "Care: Professional leather cleaning only",
      "Season: Autumn/Winter",
    ],
  },
  {
    id: 13,
    name: "SIMPLE RIB SCARF",
    price: "95.00",
    country: "Margotal",
    reviews: "189 Reviews",
    images: ["/img/1013.webp"],
    size: ["One Size"],
    description: [
      "An essential ribbed scarf in versatile olive green, knitted from soft lambswool.",
      "The simple rib pattern creates excellent stretch and texture while maintaining warmth.",
      "Generous length allows for multiple styling options - wrap once for a casual drape or twice for extra warmth.",
      "The muted olive shade is a signature Margotal colour, inspired by military and workwear.",
      "Lightweight enough for layering yet warm enough for cold weather protection.",
      "The substantial width provides good coverage without overwhelming your silhouette.",
      "Finished with clean edges that won't fray or distort over time.",
      "A timeless accessory that works with both casual and tailored outfits.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Scarves",
      "Material: 100% Lambswool",
      "Knit: Classic 2x2 rib",
      "Dimensions: 180cm x 25cm",
      "Color: Olive green",
      "Weight: Medium",
      "Care: Hand wash cold, dry flat",
      "Season: Autumn/Winter/Spring",
      "Origin: Made in Scotland",
      "Finish: Clean edges without fringing",
      "Style: Versatile, unisex design",
    ],
  },
  {
    id: 14,
    name: "MHL. RIB NECK JACKET",
    price: "485.00",
    country: "MHL.",
    reviews: "63 Reviews",
    images: ["/img/1014.webp"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    description: [
      "A contemporary workwear-inspired jacket in navy moleskin with a distinctive ribbed collar.",
      "The relaxed silhouette provides comfortable ease of movement while maintaining a structured shape.",
      "Features classic workwear details including press stud closures and utility pockets.",
      "The soft moleskin fabric has a gentle brushed surface for warmth and comfort.",
      "Ribbed collar and cuffs add sporty details to the utilitarian design.",
      "Generous fit allows for layering heavyweight knits underneath.",
      "The cropped boxy cut is perfectly proportioned for MHL.'s signature relaxed style.",
      "Versatile enough to wear as an outer layer in autumn or middle layer in winter.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Clothing, Outerwear",
      "Material: 100% Cotton moleskin",
      "Collar: Ribbed knit detail",
      "Closure: Press stud front",
      "Pockets: Patch pockets with utility details",
      "Cuffs: Ribbed knit",
      "Color: Navy",
      "Fit: Relaxed, boxy",
      "Length: Cropped at hip",
      "Care: Machine wash cold, tumble dry low",
      "Season: Autumn/Winter",
    ],
  },
  {
    id: 15,
    name: "MHL. CHUNKY FINGERLESS GLOVE",
    price: "58.00",
    country: "MHL.",
    reviews: "142 Reviews",
    images: ["/img/1015.webp"],
    size: ["One Size"],
    description: [
      "Practical fingerless gloves in charcoal grey, knitted in a warm chunky gauge.",
      "The fingerless design provides the perfect balance between warmth and functionality.",
      "Ideal for working at a desk, using your phone, or any activity requiring finger dexterity.",
      "Made from a soft wool blend that's comfortable against the skin.",
      "The chunky ribbed construction offers excellent insulation while remaining breathable.",
      "Extended wrist coverage keeps hands warm without restricting movement.",
      "The versatile charcoal shade pairs with everything in your wardrobe.",
      "A practical essential for those who need warmth without sacrificing finger mobility.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Accessories, Gloves",
      "Material: 80% Wool, 20% Nylon blend",
      "Style: Fingerless with exposed fingers",
      "Knit: Chunky ribbed texture",
      "Color: Charcoal grey",
      "Fit: One size with stretch",
      "Length: Mid-length wrist coverage",
      "Care: Hand wash cold, reshape and dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Details: Ribbed edges for secure fit",
    ],
  },
  {
    id: 16,
    name: "MHL. DEEP RIB BOBBLE HAT",
    price: "72.00",
    country: "MHL.",
    reviews: "156 Reviews",
    images: ["/img/1016.webp"],
    size: ["One Size"],
    description: [
      "A classic bobble hat in deep charcoal, featuring chunky rib knitting and a traditional pompom.",
      "The deep ribbed construction provides excellent stretch and warmth retention.",
      "Generous length allows you to wear it as a slouchy beanie or folded up for a snug fit.",
      "The substantial pompom adds a playful touch to the otherwise minimalist design.",
      "Made from soft lambswool that gets softer with wear.",
      "The deep charcoal colour is practical and versatile, working with any winter wardrobe.",
      "Perfect for outdoor activities, commuting, or casual weekend wear.",
      "A fun yet refined take on traditional winter headwear.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Accessories, Hats",
      "Material: 100% Lambswool",
      "Knit: Deep chunky rib",
      "Detail: Traditional pompom top",
      "Color: Charcoal grey",
      "Fit: One size, extra stretch",
      "Style: Slouchy or fold-up",
      "Care: Hand wash cold, dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Length: Extra deep for versatile styling",
    ],
  },
  {
    id: 17,
    name: "MHL. TIPPED FELTED GLOVE",
    price: "65.00",
    country: "MHL.",
    reviews: "118 Reviews",
    images: ["/img/1017.webp"],
    size: ["S/M", "M/L"],
    description: [
      "Elegant gloves in charcoal grey with contrasting rust orange ribbed cuffs.",
      "The felted wool construction provides excellent warmth and wind resistance.",
      "Seamless knitting ensures a smooth, comfortable fit without irritation.",
      "The pop of colour at the cuffs adds a playful detail to the classic design.",
      "Made from high-quality merino wool that's been lightly felted for durability.",
      "Touchscreen-compatible fingertips let you use devices without removing the gloves.",
      "The slim profile fits easily under coat sleeves without adding bulk.",
      "A perfect blend of practicality and style, typical of MHL.'s thoughtful design approach.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Accessories, Gloves",
      "Material: 100% Merino Wool (felted)",
      "Detail: Contrasting rust orange ribbed cuffs",
      "Color: Charcoal grey with rust orange",
      "Features: Touchscreen compatible fingertips",
      "Construction: Seamless knit",
      "Fit: Slim, true to size",
      "Care: Hand wash cold, reshape and dry flat",
      "Season: Autumn/Winter",
      "Origin: Made in Scotland",
      "Length: Standard glove length with ribbed cuff",
    ],
  },
  {
    id: 18,
    name: "COLLAGE PRINT SCARF",
    price: "145.00",
    country: "Margotal",
    reviews: "84 Reviews",
    images: ["/img/1018.webp"],
    size: ["One Size"],
    description: [
      "An artistic scarf featuring an abstract collage print in muted terracotta and grey tones.",
      "The geometric composition reflects Margotal's appreciation for modern art and architecture.",
      "Made from lightweight wool that drapes beautifully and provides warmth without weight.",
      "The colour palette of rust, grey, cream and sage creates a sophisticated, earthy aesthetic.",
      "Large square format allows for versatile styling options - wear as a scarf, shawl, or neckerchief.",
      "The print is inspired by British abstract artists and mid-century design.",
      "Hand-rolled edges ensure durability and a refined finish.",
      "A statement piece that adds artistic interest to minimal outfits.",
    ],
    Features: [
      "Brand: Margotal",
      "Category: Accessories, Scarves",
      "Material: 70% Wool, 30% Silk blend",
      "Print: Abstract collage design",
      "Dimensions: 90cm x 90cm",
      "Colors: Terracotta, grey, cream, sage, black",
      "Edges: Hand-rolled finish",
      "Weight: Lightweight",
      "Care: Dry clean only",
      "Season: All seasons",
      "Origin: Printed in England",
      "Style: Artistic, versatile square scarf",
    ],
  },
  {
    id: 19,
    name: "MHL. MOCK NECK T SHIRT",
    price: "95.00",
    country: "MHL.",
    reviews: "178 Reviews",
    images: ["/img/1019.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "A long-sleeve mock neck t-shirt in rich burgundy, cut from heavyweight cotton jersey.",
      "The relaxed fit and dropped shoulders create a contemporary, comfortable silhouette.",
      "Made from substantial cotton that holds its shape and improves with washing.",
      "The mock neck provides extra coverage and warmth without the bulk of a full turtleneck.",
      "Perfect for layering under jackets or wearing on its own as a wardrobe staple.",
      "The deep burgundy colour is a seasonal favourite that works beautifully with neutrals.",
      "Raglan sleeve construction allows for excellent freedom of movement.",
      "A versatile essential that bridges casual and smart-casual dressing.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Clothing, T-Shirts",
      "Material: 100% Organic Cotton jersey",
      "Neckline: Mock neck",
      "Sleeves: Long sleeves with raglan construction",
      "Color: Burgundy/maroon",
      "Fit: Relaxed with dropped shoulders",
      "Weight: Heavyweight jersey (220gsm)",
      "Care: Machine wash cold, tumble dry low",
      "Season: Autumn/Winter/Spring",
      "Origin: Made in Portugal",
      "Details: Clean, minimal design",
    ],
  },
  {
    id: 20,
    name: "MHL. SLEEVELESS OVERSHIRT",
    price: "265.00",
    country: "MHL.",
    reviews: "92 Reviews",
    images: ["/img/1020.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "A versatile sleeveless overshirt in deep navy, designed for layering throughout the seasons.",
      "Cut from substantial cotton moleskin with a soft, brushed surface for comfort.",
      "The sleeveless design allows for easy layering over shirts and knitwear without adding bulk.",
      "Features classic shirt detailing including a full button front and pointed collar.",
      "Chest pockets add utility and visual interest to the clean silhouette.",
      "The longer length and straight cut create a relaxed, contemporary profile.",
      "Can be worn buttoned as a vest or open as a lightweight layer.",
      "Perfect for transitional weather or as a middle layer in colder months.",
      "Embodies MHL.'s philosophy of creating versatile, functional pieces for everyday wear.",
    ],
    Features: [
      "Brand: MHL. (Margotal Line)",
      "Category: Clothing, Shirts",
      "Material: 100% Cotton moleskin",
      "Style: Sleeveless overshirt/vest",
      "Closure: Full button front with buttons",
      "Collar: Classic pointed collar",
      "Pockets: Two chest patch pockets",
      "Color: Deep navy",
      "Fit: Relaxed, longer length",
      "Care: Machine wash cold, tumble dry low",
      "Season: All seasons, ideal for layering",
      "Origin: Made in Portugal",
    ],
  },
];

export default productData;
